import React, { useState } from "react";
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Container,
} from "reactstrap";
import styles from "./styles.module.scss";

export const AccordionColumnBox = ({ customClass, post, content }) => {
  const [open, setOpen] = useState("");
  const toggle = (id) => {
    if (open === id) {
      setOpen();
    } else {
      setOpen(id);
    }
  };

  const [activeIndex, setActiveIndex] = useState(null);
  const handleHeaderClick = (index) => {
    if (activeIndex === index) {
      setActiveIndex(null);
    } else {
      setActiveIndex(index);
    }
  };

  return (
    <section className={`${styles.root} ${customClass}`}>
      <Container>
        <div dangerouslySetInnerHTML={{ __html: content }} />
        <Accordion open={open} toggle={toggle} className="row">
          {post?.map((post, index) => (
            <AccordionItem
              key={index}
              className={`border-0 position-relative bg-transparent mb-4`}
            >
              <div className="p-4 wrapper p-4 rounded-4">
                <AccordionHeader
                  targetId={`${index}`}
                  tag="div"
                  className=""
                  onClick={() => handleHeaderClick(`${index}`)}
                >
                  {post?.title}
                </AccordionHeader>
                {post?.content_preview ? (
                  <p
                    className={`content-preview ${
                      activeIndex == index ? "active" : ""
                    }`}
                  >
                    {post?.content_preview}
                  </p>
                ) : null}
                <AccordionBody accordionId={`${index}`}>
                  {post?.content ? (
                    <div
                      className=""
                      dangerouslySetInnerHTML={{ __html: post?.content }}
                    />
                  ) : null}
                </AccordionBody>
              </div>
            </AccordionItem>
          ))}
        </Accordion>
      </Container>
    </section>
  );
};

export default AccordionColumnBox;
